import React, { Component, Fragment } from "react";
import { Form } from "react-bootstrap";
import { Dropdown } from "semantic-ui-react";
import AlertNoPermission from "../../alerts/AlertNoPermission";

class ApplicationTypes extends Component {
    state = { applicationTypesList: [], noPermission: false };

    getApplicationTypes = async () => {
        const { fetchURL, defaultValue, onShowAlert, t } = this.props;
        try {
            const response = await fetch(`${fetchURL}/application-types`, {
                credentials: "include",
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
            });
            if (response.status === 200) {
                await response.json().then((fetchedData) => {
                    //console.log(fetchedData);
                    if (fetchedData.status === "noPermission") this.setState({ noPermission: true });
                    else if (fetchedData.status === "notLogged") this.props.onShowHomePage();
                    else if (fetchedData.status === false) onShowAlert({ variant: "danger", message: t(`error.${fetchedData.code}`) });
                    else {
                        const appTypesList = fetchedData.partAppTypesList;
                        if (defaultValue === "all") {
                            appTypesList.push({
                                key: appTypesList.length + 1,
                                value: "all",
                                text: t("selectAll"),
                            });
                        }

                        this.setState({ applicationTypesList: appTypesList });
                    }
                });
            }
        } catch (err) {
            onShowAlert({ variant: "danger", message: `${t("error.cannotFetchData")} (${err})` });
            this.setState({ loading: false });
        }
    };

    componentDidMount() {
        this.getApplicationTypes();
    }

    render() {
        const { applicationTypesList, noPermission } = this.state;
        const { defaultValue, onPartAppTypeSelected, req, t } = this.props;
        return (
            <Fragment>
                <Form.Label>
                    {t("applications.appTypes")} {req && <span className="required">*</span>}
                </Form.Label>
                {noPermission ? (
                    <AlertNoPermission t={t} />
                ) : (
                    <Dropdown
                        value={defaultValue}
                        id="appStatDropdown"
                        className={req ? "req mb-3" : "mb-3"}
                        placeholder={t("applications.clickToChooseType")}
                        fluid
                        selection
                        options={applicationTypesList}
                        onChange={(event, { value }) => {
                            onPartAppTypeSelected(value);
                        }}
                    />
                )}
            </Fragment>
        );
    }
}

export default ApplicationTypes;
